import { createApiClient } from "@/app/lib/api/createClient";

export const internalApiClient = createApiClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
  withCredentials: true,
});
